import { Center, Paper, Title, Text, Button, Stack } from '@mantine/core';
import { IconError404 } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <Center style={{ minHeight: '60vh' }}>
      <Paper shadow="md" p="xl" radius="md" withBorder>
        <Stack align="center" gap="md">
          <IconError404 size={64} color="var(--mantine-color-dimmed)" />
          <Title order={2}>Page Not Found</Title>
          <Text c="dimmed" ta="center" maw={400}>
            The page you are looking for does not exist or has been moved.
          </Text>
          <Button onClick={() => navigate('/')}>Back to Home</Button>
        </Stack>
      </Paper>
    </Center>
  );
}
